/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_Frame_Rate_HelpInputs */

const en_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the frame rate of your target material`)
};

const fr_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez la fréquence d’images de votre cible`)
};

const de_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Bildrate Ihres Zielmaterials.`)
};

const it_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la frequenza dei fotogrammi del materiale di destinazione`)
};

const ru_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите частоту кадров целевого материала.`)
};

const es_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione la velocidad de fotogramas de su material de destino`)
};

const zh_cn2_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择目标素材的帧速率`)
};

const ja_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象素材のフレームレートを選択します`)
};

const hi_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी लक्षित सामग्री की फ्रेम दर चुनें`)
};

const pt_pt2_target_frame_rate_help = /** @type {(inputs: Target_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a taxa de quadros do seu material de destino.`)
};

/**
* | output |
* | --- |
* | "Select the frame rate of your target material" |
*
* @param {Target_Frame_Rate_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_frame_rate_help = /** @type {((inputs?: Target_Frame_Rate_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_Frame_Rate_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_target_frame_rate_help(inputs)
	if (locale === "de") return de_target_frame_rate_help(inputs)
	if (locale === "it") return it_target_frame_rate_help(inputs)
	if (locale === "ru") return ru_target_frame_rate_help(inputs)
	if (locale === "es") return es_target_frame_rate_help(inputs)
	if (locale === "zh-CN") return zh_cn2_target_frame_rate_help(inputs)
	if (locale === "ja") return ja_target_frame_rate_help(inputs)
	if (locale === "hi") return hi_target_frame_rate_help(inputs)
	if (locale === "pt-PT") return pt_pt2_target_frame_rate_help(inputs)
	return en_target_frame_rate_help(inputs)
});